<div class="funds">
  <div class="row">
    <div class="title-name">Emisora</div>
  </div>
  <div class="header-blotter">
    <div class="search">
      <input
        #filter
        type="text"
        required
        (ngModelChange)="filterData($event)"
        maxlength="15"
        (click)="$event.target.select()"
      />
      <label>Buscar una emisora</label>
    </div>
    <div
      *ngIf="showDownloadExcel"
      class="end-xs download-csv"
      (click)="generateExcel()"
      [ngClass]="pointerDisabled ? 'pointer-disabled' : ''"
    >
      Descargar excel
    </div>
  </div>
  <div class="table-blotter">
    <div class="scroll">
      <table>
        <thead>
          <tr>
            <td
              class="li-headers-format found"
              (click)="setSortingProp('processDate')"
            >
              <span>Hora</span>
            </td>
            <td class="li-headers-format found">
              <span class="folio">Folio</span>
            </td>
            <td
              class="li-headers-format found"
              (click)="setSortingProp('fund')"
            >
              <span class="fund-name">Fondo</span>
              <div class="sort-icon fund-name"></div>
            </td>
            <td class="li-headers-format found" (click)="setSortingProp('way')">
              <span class="fund-way">Sentido</span>
              <div class="sort-icon fund-way"></div>
            </td>
            <td
              class="li-headers-format found"
              (click)="setSortingProp('settlementDate')"
            >
              <span>Liquidación</span>
              <div class="sort-icon settlement"></div>
            </td>

            <td class="li-headers-format-number found">
              <span class="fund-titles">Títulos</span>
            </td>
            <td class="li-headers-format-number found">
              <span class="fund-price">Precio</span>
            </td>

            <td class="li-headers-format-number found">
              <span class="fund-total">Total</span>
            </td>
          </tr>
        </thead>
        <tbody *ngIf="!showSkeleton">
          <tr
            *ngFor="
              let c of orders;
              let index = index;
              let odd = odd;
              let even = even
            "
          >
            <td class="li-headers-format found">
              <span>{{ c.hour }}</span>
            </td>
            <td class="li-headers-format-number found">
              <span class="folio">{{ c.folio }}</span>
            </td>
            <td class="li-headers-format found">
              <span class="fund-name">{{ c.fund }}</span>
            </td>
            <td class="li-headers-format-number found">
              <span class="fund-way">{{ c.way }}</span>
            </td>
            <td class="li-headers-format found">
              <span>{{ c.settlementDate }}</span>
            </td>
            <td class="li-headers-format-number found">
              <span class="fund-titles" data-recording-sensitive>{{
                c.shares | hbCustomFormat: '0,0'
              }}</span>
            </td>
            <td class="li-headers-format-number found">
              <span class="fund-price" data-recording-sensitive>{{
                c.price | hbCustomFormat: '$0,0[.]000'
              }}</span>
            </td>
            <td class="li-headers-format-number found">
              <span class="fund-total" data-recording-sensitive>{{
                c.total
                  | hbCustomFormat: (c.total < 1 ? '$0,0[.]00[0]' : '$0,0[.]00')
              }}</span>
            </td>
          </tr>
        </tbody>
        <tbody *ngIf="showSkeleton">
          <tr *ngFor="let c of ordersEmptyState">
            <td class="li-headers-format found">
              <span class="skeleton"></span>
            </td>
            <td class="li-headers-format found">
              <span class="skeleton"></span>
            </td>
            <td class="li-headers-format found">
              <span class="skeleton"></span>
            </td>
            <td class="li-headers-format-number found">
              <span class="skeleton"></span>
            </td>
            <td class="li-headers-format-number found">
              <span class="skeleton"></span>
            </td>
            <td class="li-headers-format-number found">
              <span class="skeleton"></span>
            </td>
            <td class="li-headers-format-number found">
              <span class="skeleton"></span>
            </td>
            <td class="li-headers-format-number found">
              <span class="skeleton"></span>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="none-rows" *ngIf="totalRows === 0 && !showSkeleton">
        <i class="icon icon-atm-icn-ordenes"></i>
        <div>Aún no tienes órdenes</div>
      </div>
    </div>
  </div>
  <div class="order-number" *ngIf="totalRows > 0">
    <span>{{ orders.length }} / {{ orders.length }} registros</span>
  </div>
</div>
